import React, { useState } from 'react';

import blankIcon from 'assets/svg/blank.svg';
import styles from './styles.module.scss';

import { Modal } from 'components/modal/Modal';
import { PrimaryPinkButton } from 'components/buttons/PrimaryPinkButton';
import { SecondPinkButton } from 'components/buttons/SecondPinkButton';
import { TermsAndConditionsModal } from 'components/glamstar/TermsAndConditionsModal';

export function AcceptTermsModal({ onCloseModal, onConfirmTerms }) {
  const [showModal, setShowModal] = useState(false);
  const [checkTerms, setCheckTerms] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleConfirmTerms() {
    if (!checkTerms) {
      return;
    }

    try {
      setLoading(true);
      await onConfirmTerms();
    } catch (e) {
      throw new Error(e);
    } finally {
      setLoading(false);
    }
  }

  function handleOpenModal() {
    setShowModal(true);
  }

  function handleCloseModal() {
    setShowModal(false);
  }

  return (
    <div id={styles.termsModal}>
      <div className={styles.modalHeader}>
        <h1 className={styles.title}>Termos e condições</h1>
        <p className={styles.description}>
          Você precisa aceitar os Termos e Condições para participar do Glamstar
          2022
        </p>
      </div>
      <div className={styles.modalBody}>
        <img className={styles.icon} src={blankIcon} alt="Termos e condições" />
        <button className={styles.showTermsButton} onClick={handleOpenModal}>
          {' '}
          Clique para ver os Termos e Condições
        </button>
        <div className={styles.termsBox}>
          <input
            type="checkbox"
            name="terms"
            id="terms"
            checked={checkTerms}
            onChange={() => setCheckTerms(!checkTerms)}
          />
          <label htmlFor="terms">
            Concordo com os termos e condições de uso
          </label>
        </div>
      </div>

      <div className={styles.modalFooter}>
        <PrimaryPinkButton
          onClick={handleConfirmTerms}
          disabled={!checkTerms || loading}
        >
          {loading ? 'Aguarde...' : 'Continuar'}
        </PrimaryPinkButton>
        <SecondPinkButton onClick={onCloseModal}>Voltar</SecondPinkButton>
      </div>

      <Modal
        visible={showModal}
        onCloseModal={handleCloseModal}
        disableBackdropClose
      >
        <TermsAndConditionsModal />
      </Modal>
    </div>
  );
}
